import createAPIAction from 'store/utils/createAPIAction';
import createAction from 'store/utils/createAction';
import { graphQLService } from '../mpi/actions';
import { getAllInspectionRsRepairsQuery } from './queries';

const serviceName = 'repairs';

interface ISearchRepairsParams {
  searchTerms?: string;
  from?: number;
  pageSize?: number;
  cancelTokenSource?: any;
  searchLevel: number;
  fleetId?: string;
}

export const searchRepairs = createAPIAction(
  `${serviceName}/SEARCH_RS_REPAIRS`,
  (data: ISearchRepairsParams) => ({
    endpoint: '/search-service/search',
    method: 'POST',
    data,
  })
);

export const searchFMCRepairs = createAPIAction(
  `${serviceName}/GET_FMC_REPAIRS`,
  (customRepairText: any, fmcType: string) => ({
    endpoint: '/pricing-service/admin/fmc/repairs',
    method: 'GET',
    params: { customRepairText, fmcType },
  })
);

export const getAllRepairs = createAPIAction(
  `${serviceName}/GET_REPAIRS`,
  () => ({
    endpoint: '/pricing-service/search/repairs',
  })
);

export const getAllInspectionRsRepairs = createAPIAction(
  `${serviceName}/GET_RS_REPAIRS`,
  () => ({
    endpoint: graphQLService,
    method: 'POST',
    data: getAllInspectionRsRepairsQuery,
  })
);

export const setCustomRequestSearchString = createAction(
  `${serviceName}/SET_CUSTOM_REQUEST_SEARCH_STRING`
);

export const setSelectedRepair = createAction<{
  repairId: number;
  name: string;
}>(`${serviceName}/SET_SELECTED_REPAIR`);
